export default "__VITE_ASSET__MfDjYKa4__"